import { COLOR, histogram, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'AO',
  version: 2,
  label: 'Awesome Oscillator',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 110,
  inputs: [period('fastperiod', 5, 'Fast length'), period('slowperiod', 34, 'Slow length')],
  outputs: [histogram('ao', 'AO', COLOR.green, COLOR.red)],
  talib: {
    functions: ['SMA', 'MEDPRICE'],
    expr: 'SMA(MEDPRICE(high, low), timeperiod={fastperiod}) - SMA(MEDPRICE(high, low), timeperiod={slowperiod})',
  },
  listed: true,
  tailSafe: true,
  lookback: ({ fastperiod, slowperiod }) => Math.max(fastperiod, slowperiod) - 1,
}
export default def
